// Generated from SVG to Code Figma Plugin

export const BaseLineNewcreator = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2 4C2 3.44771 2.44771 3 3 3H7.87531C8.58796 3 9.26378 3.31654 9.72001 3.86401L10.78 5.13599C11.2362 5.68346 11.912 6 12.6247 6H20C20.5523 6 21 6.4477 21 7V20C21 20.5523 20.5523 21 20 21H3C2.44771 21 2 20.5523 2 20V4Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path d="M8.49414 13.5015H14.4941" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
    <path d="M11.5 10.4956V16.4956" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
  </svg>
);
